import { useRef } from 'react'

const useMoveScroll = () => {
  const RefElement = useRef<HTMLImageElement | null>(null)
  const RefInput   = useRef<HTMLInputElement | null>(null)

  const onMoveToElement = () => {
    const el = RefElement.current
    if (!el) return

    el.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' })

    const focusLater = () => {
      setTimeout(() => {
        try {
          RefInput.current?.focus()
          const v = RefInput.current?.value ?? ''
          RefInput.current?.setSelectionRange?.(v.length, v.length)
        } catch {}
      }, 120)
    }

    const vv = (window as any).visualViewport as VisualViewport | undefined
    const realign = () => {
      el.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' })
      focusLater()
      vv?.removeEventListener('resize', realign)
      vv?.removeEventListener('scroll', realign)
    }

    if (vv) {
      vv.addEventListener('resize', realign, { once: true })
      vv.addEventListener('scroll', realign, { once: true })
      setTimeout(realign, 80)
    } else {
      focusLater()
    }
  }

  return { RefInput, RefElement, onMoveToElement }
}

export default useMoveScroll
